export const RegularExpressions = {
    noSpaces: /^\S*$/
};
